<template>
    <div>
        <vs-card title="Background Pick" class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Background Pick</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Delivery Order Reference *" v-model="do_reference" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-full">
                            <label for="" class="vs-input--label">Movement Date *</label>
                            <flat-pickr class="w-full" v-model="movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
            <vs-table multiple v-model="selected" :data="drafts" stripe>
                <template slot="thead">
                    <vs-th>Line ID</vs-th>
                    <vs-th>Product ID</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th>Pack ID</vs-th>
                    <vs-th>Batch</vs-th>
                    <vs-th>Exp. Date</vs-th>
                    <vs-th>Qty</vs-th>
                    <vs-th>UoM</vs-th>
                    <vs-th>Stock Type</vs-th>
                    <vs-th>Location Type</vs-th>
                    <vs-th>Location ID</vs-th>
                    <vs-th>Storage Unit</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].line_id }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].do_detail.product.product_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].do_detail.product.description_1 }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].inventory ? data[indextr].inventory.pack_id : data[indextr].do_detail.pack_id }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].inventory ? data[indextr].inventory.batch : data[indextr].do_detail.batch }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].inventory ? data[indextr].inventory.expired_date : data[indextr].do_detail.expired_date }}
                    </vs-td>
                    
                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].base_qty}}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].do_detail.base_uom.name }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].do_detail.stock_type.name }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].inventory ? data[indextr].inventory.locations_type.code : '' }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].inventory ? data[indextr].inventory.location.location_code : '' }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].storage_unit ? data[indextr].storage_unit : '' }}
                    </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vs-card>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components:{
        flatPickr,
    },
    data() {
        return {
            selected: [],
            drafts: [],
            do_reference: '',
            movement_date: new Date(),
            isLoading: false,
            maxRetry: 10
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        fetchData() {
            this.maxRetry--
            this.isLoading = true
            const dataSend = {
                do_id: this.$route.params.id
            }
            Promise.all([this.$http.post('pick/getpickpartition', dataSend), this.$http.get('outbound/deliveryorder/' + this.$route.params.id)])
            .then(this.$http.spread((res, deliveryorder) => {
                this.isLoading = false
                res.data.map(item => {
                    this.drafts.push(item)
                    this.do_reference = deliveryorder.data.do_reference

                    if(item.inventory_first_id) {
                        this.selected.push(item)
                    }
                })
            }))
            .catch(() => {
                if(this.maxRetry < 0){
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.maxRetry = 10
                            this.fetchData()
                        },
                        cancel: () => this.$router.push({ name: 'delivery-order-view', params: {id: this.$route.params.id} }),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                    return;
                }
                this.fetchData()
            })
        },
        back() {
            this.$vs.dialog({
                color: 'warning',
                title: 'Leave Page',
                text: 'Changes you made may not be saved?',
                acceptText: 'Leave Page',
                accept: () => this.$router.push({ name: 'delivery-order-view', params: {id: this.$route.params.id} }),
            })
        },
        submitForm() {
            let error = false
            const moHead = {
                do_id: this.$route.params.id,
                movement_date: this.movement_date
            }

            const details = []

            if(this.selected.length <= 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No item selected'
                })
                return false
            }

            this.selected.map(item => {
                if(!item.inventory) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Line ' + item.line_id + '. No location assigned'
                    })

                    error = true
                }
                else {
                    details.push({
                        line_id: item.line_id,
                        do_detail_id: item.do_detail.id,
                        base_qty: item.base_qty,
                        location_id: item.location_id,
                        storage_unit: item.inventory_first_id
                    })
                }
            })

            if(error) {
                return false
            }
            else {
                this.isLoading = true
                const dataSend = {
                    mo_head: moHead,
                    details: details
                }

                this.$http.post('pick/createmo', dataSend)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully'
                    })
                    this.$router.push({ name: 'delivery-order-view', params: {id: this.$route.params.id} })
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'

                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
                .then(() => this.isLoading = false)
            }
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>